import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import api from '../api';
import DailyEditor from '../components/DailyEditor';
import TopicEditor from '../components/TopicEditor';
import AdminChat from '../components/AdminChat';

function Admin({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/admin' && location.pathname === '/admin') return true;
    if (path !== '/admin' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <div className="admin-shell">
      <aside className="admin-side">
        <div className="admin-logo">inside me.</div>
        <nav className="admin-menu">
          <button className={`admin-menu-item ${isActive('/admin') && !isActive('/admin/topics') && !isActive('/admin/chat') ? 'active' : ''}`} onClick={() => navigate('/admin')}>
            Today's Entry
          </button>
          <button className={`admin-menu-item ${isActive('/admin/topics') ? 'active' : ''}`} onClick={() => navigate('/admin/topics')}>
            Thoughts
          </button>
          <button className={`admin-menu-item ${isActive('/admin/chat') ? 'active' : ''}`} onClick={() => navigate('/admin/chat')}>
            Messages
          </button>
          <button className="admin-menu-item" onClick={() => navigate('/')}>
            View Site
          </button>
        </nav>
        <div style={{ borderTop: '1px solid var(--border-soft)', paddingTop: '16px' }}>
          <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', padding: '0 14px', marginBottom: '8px' }}>
            {user.username}
          </div>
          <button className="admin-menu-item" onClick={onLogout}>Sign out</button>
        </div>
      </aside>

      <main className="admin-main">
        <Routes>
          <Route path="/" element={<DailyEditor />} />
          <Route path="/day/:date" element={<DailyEditor />} />
          <Route path="/topics" element={<TopicsList />} />
          <Route path="/topics/new" element={<TopicEditor />} />
          <Route path="/topics/edit/:id" element={<TopicEditor />} />
          <Route path="/chat" element={<AdminChat />} />
        </Routes>
      </main>
    </div>
  );
}

function TopicsList() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchTopics = useCallback(async () => {
    try {
      const { data } = await api.get('/topics');
      setTopics(data.topics);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchTopics(); }, [fetchTopics]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this thought?')) return;
    await api.delete(`/topics/${id}`);
    fetchTopics();
  };

  if (loading) return <div className="loading">...</div>;

  return (
    <div>
      <div className="admin-header">
        <h1>Your Thoughts</h1>
        <button className="btn btn-primary" onClick={() => navigate('/admin/topics/new')}>+ New</button>
      </div>

      {topics.length === 0 ? (
        <div className="empty">
          <h2>No thoughts yet</h2>
          <p>Write something when the mood strikes.</p>
        </div>
      ) : (
        <div className="topics-grid">
          {topics.map(t => (
            <div key={t.id} className="topic-card" style={{ cursor: 'default' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }} onClick={() => navigate(`/admin/topics/edit/${t.id}`)}>
                  {t.category && <div className="topic-category">{t.category}</div>}
                  <div className="topic-title">{t.title}</div>
                  <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    {format(new Date(t.created_at), 'MMM d, yyyy')}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button className="btn btn-ghost" onClick={() => navigate(`/admin/topics/edit/${t.id}`)}>Edit</button>
                  <button className="btn btn-danger" onClick={() => handleDelete(t.id)}>Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Admin;
